import { createSelector } from 'reselect';
import omit from 'lodash/omit';
import qs from 'query-string';
import { getQueryParams } from 'store/router/routerSelectors/getQueryParams';

export const getMapLinkQueryString = createSelector(getQueryParams, (query) => {
  const mapQuery = omit(query, ['page']);
  return qs.stringify(mapQuery);
});
